import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { formats, modules } from '../constants/common';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const TextEditor = ({
  id,
  name,
  value,
  className = '',
  onEditorChange,
  onBlur,
  error,
  helperText
}) => {
  const quillRef = useRef(null);

  // Normalize Quill content: if only placeholder tags remain, treat as empty
  const handleChange = (content, delta, source, editor) => {
    const plainText = editor.getText().trim();
    const normalized = plainText.length === 0 ? '' : content;
    onEditorChange(normalized);
  };

  // Wrap ReactQuill's blur to notify parent form of touch
  const handleBlur = () => {
    if (onBlur) {
      onBlur({ target: { name } });
    }
  };

  const wrapperClasses = `${className} ${error ? 'editor-error' : ''}`.trim();

  return (
    <div id={id} className={wrapperClasses}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        placeholder="Write your description here..."
        modules={modules}
        formats={formats}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {error && helperText && <div className="error-message">{helperText}</div>}
    </div>
  );
};

TextEditor.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  className: PropTypes.string,
  onEditorChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string
};
